import { render, staticRenderFns } from "./technical-sheet-select.vue?vue&type=template&id=20f510ea&scoped=true&"
import script from "./technical-sheet-select.vue?vue&type=script&lang=js&"
export * from "./technical-sheet-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f510ea",
  null
  
)

export default component.exports